<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <!-- <el-form-item label="客户信息：">
              <el-input v-model="query.keyword" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item> -->
            <el-form-item label="区域：">
              <el-cascader v-model="query.addrid" :props="cascaderProps" collapse-tags :options="addressList"
                :show-all-levels="false" clearable placeholder="请选择所属区域" size="small"></el-cascader>
            </el-form-item>
            <el-form-item label="身份：">
              <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
                <el-option :label="item.name" :value="item.level" v-for="(item,index) in businessOption" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="客户信息" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.name }}</span>
                <span style="display: block;">{{ row.pho }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="用友编码" prop="yongYouCode" align="center"></el-table-column>
          <el-table-column label="所属区域" prop="area" align="center">
            <template slot-scope="{row}">
              {{row.provinceName}}{{row.cityName}}{{row.areaName}}
            </template>
          </el-table-column>
          <el-table-column label="售后数" prop="afterCount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="售后补差金额" prop="repairMoney" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.repairMoney }}</span>
              <el-button type="primary" size="mini" @click="toPage('/order/afterorder',row.name)">订货明细</el-button>
            </template>
          </el-table-column>
          <el-table-column label="换货订单" prop="exchangeCount" sortable="custom" align="center" width="100">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.exchangeCount }}</span>
              <el-button type="primary" size="mini"  @click="toPage('/order/changeorder',row.name)">订货明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import Pagination from '@/components/Pagination'
import Times from '../components/times.vue'
import Navs from '../components/navs.vue'
import sysAddrApi from '@/api/sys/sysAddr'
import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // isDisplay: 1,
        // keyword:'',
        // identity:''
      },
      selectItems: [],
      times: null,
      businessOption: [],
      navIndex: 0,
      addressList: [],
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        // multiple: true
      },
       today:'',
    }
  },
  created() {
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times={
      timeStart:`${this.today} 00:00:00`,
      timeEnd:`${this.today} 23:59:59`,
    }
    this.getAddressList()
    this.getBusinessStanding()
    this.getOption()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    toPage(url,name){
      this.$router.push({path:url,query:{'name':name}})
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.businessOption.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    // 获取客户
    getOption() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.businessOption.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    handleDownload(){
      this.$router.push("/export/list?code=findAfterTotalExportByQuery")
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({
        data
      }) => {
        this.addressList = this.formatCascaderData(data)
        // console.log('地区列表: ',data);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'afterCount': 'afterCountSortSign',
        'repairMoney': 'repairMoneySortSign',
        'exchangeCount': 'exchangeCountSortSign',
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
     getTime(event) {
      this.times = JSON.parse(event)
      if(!this.times.ifUse){
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
     handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query={
        pageNo: 1,
        pageSize: 10,
      }
      this.times = {
        timeStart:`${this.today} 00:00:00`,
        timeEnd:`${this.today} 23:59:59`,
       }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
        this.navIndex = index;
        this.doQueryList({ pageNo: 1 });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      let query={...this.query}
      if(this.times && this.times.timeStart){
        query.startTime=this.times.timeStart
        query.endTime=this.times.timeEnd
      }
      if(!query.levelId) delete query.levelId
      return goodsOrderApi.findAfterTotalByPage(query).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
  }
}
</script>
<style scoped lang="scss">
  .nav-container{
    display: flex;
    justify-content: flex-end;
  }
  .filter-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 0;
    .times {
      display: flex;
      align-items: center;
    }
    .btns {
      margin-bottom: 22px;
    }
  }
</style>
